import InfoCard from '../Card/InfoCard';

interface NewUserCardProps {
  email: string;
}

const NewUserCard = ({ email }: NewUserCardProps) => (
  <InfoCard
    title="Vi skapar ett konto till dig"
    body={
      <>
        Ett konto med e-postadress {email} kommer att skapas. Du får ett mejl
        där du bekräftar ditt konto och väljer lösenord när betalningen är
        slutförd.
      </>
    }
  />
);

export default NewUserCard;
